import { AvatarWrapper } from './AvatarWrapper';

export default AvatarWrapper;
